import { FOCUS, TIMELINE } from "../data/constants";
import resumePDF from "../assets/Nisarg_Patel.pdf";
import { IconDownload } from "./icons";

export default function About() {
  return (
    <section id="about" className="sec">
      <p className="sec-marker reveal">{"/* about me */"}</p>

      <div className="grid-split">
        <div>
          <h2 className="h2 reveal d1">
            What I actually<br /><span className="ghost">work on.</span>
          </h2>

          <p className="prose reveal d2" style={{ marginTop: 24 }}>
            I am a <span className="t-mark">software engineer at Manulife</span>, where I build
            Java and Spring Boot microservices for policy, claims, and payments, and the
            <span className="t-str"> Angular</span> front-ends customers actually touch. Insurance
            is unforgiving about correctness, so most of my day is spent on event-driven
            services, secure auth, and tests that catch the thing before a customer does.
          </p>

          <p className="prose reveal d3" style={{ marginTop: 16 }}>
            I read other people's code more than I write my own — and in a codebase this size
            that is most of the job. That is where the habit comes from:{" "}
            <span className="t-hi">boring code, clear names, small functions</span>. It is slower
            on day one and much faster every day after.
          </p>

          <a className="btn reveal d4" href={resumePDF} download style={{ marginTop: 28 }}>
            <IconDownload /> Download résumé
          </a>
        </div>

        <div className="reveal d3">
          <p className="sec-marker">{"// timeline"}</p>
          {TIMELINE.map((t) => (
            <div className="row-item" key={t.title}>
              <span className="row-year">{t.year}</span>
              <span>
                <span style={{ color: "var(--fg)", fontSize: 12 }}>{t.title}</span>
                <span style={{ color: "var(--fg-mute)", fontSize: 11, display: "block", marginTop: 3 }}>
                  {t.place}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Focus areas ─────────────────────────────────────────────────── */}
      <p className="sec-marker reveal" style={{ marginTop: 72 }}>{"// what I do"}</p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 30 }}>
        {FOCUS.map((f, i) => (
          <div key={f.n} className={`reveal d${i + 1}`}>
            <h3 className="h3" style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
              <span className="t-num" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11 }}>
                {f.n}
              </span>
              {f.title}
            </h3>
            <ul style={{ listStyle: "none", marginTop: 14, display: "flex", flexDirection: "column", gap: 9 }}>
              {f.items.map((item) => (
                <li key={item} style={{ fontSize: 11.5, lineHeight: 1.7, color: "var(--fg-dim)", display: "flex", gap: 9 }}>
                  <span className="t-com" aria-hidden="true">—</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
